import { buildBackgroundColorClassname, buildBackgroundGradientClassname, buildBackgroundImageClassname } from './classNameUtils';
import { isBackgroundLayerColor, isBackgroundLayerImage } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';
export const convertPositionValueToPositionStyleString = positionValue => {
  switch (positionValue) {
    case 'TOP_LEFT':
      return 'left top';
    case 'TOP_CENTER':
      return 'center top';
    case 'TOP_RIGHT':
      return 'right top';
    case 'MIDDLE_LEFT':
      return 'left center';
    case 'MIDDLE_CENTER':
      return 'center center';
    case 'MIDDLE_RIGHT':
      return 'right center';
    case 'BOTTOM_LEFT':
      return 'left bottom';
    case 'BOTTOM_CENTER':
      return 'center bottom';
    case 'BOTTOM_RIGHT':
      return 'right bottom';
    default:
      throw new Error(`Invalid background position value: ${positionValue.toString()}`);
  }
};
function convertHorizontalSideToCssKeyword(side) {
  switch (side) {
    case 'LEFT':
      return 'left';
    case 'RIGHT':
      return 'right';
    default:
      return '';
  }
}
function convertVerticalSideToCssKeyword(side) {
  switch (side) {
    case 'TOP':
      return 'top';
    case 'BOTTOM':
      return 'bottom';
    default:
      return '';
  }
}
export function writeBackgroundImageCss(backgroundImage) {
  const objectFit = backgroundImage.backgroundSize;
  return `object-fit: ${objectFit.toLowerCase()}; \n object-position: ${convertPositionValueToPositionStyleString(backgroundImage.backgroundPosition)}; \n width: 100%; \n height: 100%;`;
}
export function writeBackgroundGradientCss(styleValue) {
  // TODO: In the future we may support different types of gradients, when that happens we should split the linear gradient stuff into it's own method
  let direction = 'to';
  if (styleValue.sideOrCorner.verticalSide) {
    direction = `${direction} ${convertVerticalSideToCssKeyword(styleValue.sideOrCorner.verticalSide)}`;
  }
  if (styleValue.sideOrCorner.horizontalSide) {
    direction = `${direction} ${convertHorizontalSideToCssKeyword(styleValue.sideOrCorner.horizontalSide)}`;
  }
  const colorStopsCss = styleValue.colors.map(stop => `rgba(${stop.red}, ${stop.green}, ${stop.blue}, ${stop.alpha})`);
  return `linear-gradient(${direction}, ${colorStopsCss.join(',')})`;
}
export function writeBackgroundColorStyles(backgroundColor) {
  const {
    red,
    green,
    blue,
    alpha
  } = backgroundColor.color;
  return `background-color: rgba(${red}, ${green}, ${blue}, ${alpha}); width: 100%; height: 100%;`;
}
export function writeBackgroundLayersToCss(nodeId, layers, backgroundLayerStylesByBreakpointName) {
  Object.entries(layers).forEach(([breakpointName, layersForBreakpoint]) => {
    const stylesForBreakpoint = backgroundLayerStylesByBreakpointName[breakpointName] || [];
    layersForBreakpoint.forEach((layer, index) => {
      if (isBackgroundLayerImage(layer)) {
        stylesForBreakpoint.push([`.${buildBackgroundImageClassname(nodeId, breakpointName, index)}`, writeBackgroundImageCss(layer)]);
      } else if (isBackgroundLayerColor(layer)) {
        stylesForBreakpoint.push([`.${buildBackgroundColorClassname(nodeId, breakpointName, index)}`, writeBackgroundColorStyles(layer)]);
      } else {
        stylesForBreakpoint.push([`.${buildBackgroundGradientClassname(nodeId, breakpointName, index)}`, `background: ${writeBackgroundGradientCss(layer)}; width: 100%; height: 100%;`]);
      }
    });
    backgroundLayerStylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
}